// extracted by mini-css-extract-plugin
export default {"container":"Card_container__K7EcC","box":"Card_box__oFM6q"};